import { Button, useEffect } from '@factorialco/deprecated-design-system'
import { SettingsStepsLegalEntityFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import { loginPath } from 'modules/payroll_integrations_datev_lauds/lib/OauthService'
import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

const DATEV_FORM_DATA_KEY = 'datev_lauds_form_data'

interface Props {
  legalEntity: SettingsStepsLegalEntityFragment
  data: DatevWizardData
  setShowModal: (value: boolean) => void
  onChange: (value: string) => void
  clientCode: string
  companyId: number
  onDataChanged: (data: DatevWizardData) => void
}

export const OfflineAccessModal = ({
  legalEntity,
  data,
  setShowModal,
  onChange,
  clientCode,
  companyId,

  onDataChanged,
}: Props) => {
  const legalEntityKey = `legal_entity_${legalEntity.id}`
  const clientId = `${data.answers.consultant_id}-${clientCode}`

  const isBookkeeperView = useBookkeeperView()
  const loginUrl = buildUrl(
    `${loginPath()}/?company_id=${companyId}&bookkeeper_view=${isBookkeeperView}&client_id=${clientId}`
  )

  useEffect(() => {
    if (clientCode) {
      const updatedData = {
        ...data,
        answers: {
          ...data.answers,
          [legalEntityKey]: clientCode,
        },
      }
      onDataChanged(updatedData)
    }
  }, [clientCode, legalEntityKey])

  const login = () => {
    const finalData = {
      ...data,
      answers: {
        ...data.answers,
        [legalEntityKey]: clientCode,
        [`client_id_${legalEntity.id}`]: clientId,
      },
    }

    // Store the complete data structure
    localStorage.setItem(DATEV_FORM_DATA_KEY, JSON.stringify(finalData))

    setTimeout(() => {
      window.location.href = loginUrl
    }, 3000)
  }

  return (
    <Modal
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.connect_modal_title'
      )}
      description={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.connect_modal_description',
        { legal_entity_name: legalEntity.legalName }
      )}
      illustration="alert"
      onClose={() => setShowModal(false)}
      footer={
        <>
          <Button type="secondary" onClick={() => setShowModal(false)}>
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.cancel'
            )}
          </Button>
          <Button onClick={login}>
            {i18n.t(
              'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.login.offline_access_token.connect'
            )}
          </Button>
        </>
      }
    >
      <TextField value={clientCode} onChange={onChange} placeholder="123456" />
    </Modal>
  )
}
